module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/le-api-71817ca4e156b87e46f9b4e4dc22924c.png";